import { marketBasedRECField, MAX_FOUR_DECIMALS_REGEX, requiredErrorMessage } from 'constants/constants';
import * as Yup from 'yup';
import { maxFourDecimalsTest, sectionSchema } from '../ScopeOneViewComponent/validationSchema';

export const scopeTwoValidationSchema = Yup.object().shape({
  locationBased: sectionSchema,
  marketBased: sectionSchema,
  // Un comment after client give confirmation
  // marketBased: Yup.array().of(Yup.object({
  //   fuelName: Yup.string().nullable(),
  //   fuelValue: maxFourDecimalsTest,
  //   electricityFromRec: Yup.object({
  //     emissionValue: Yup.string().typeError(requiredErrorMessage),
  //     providerName: Yup.string().typeError(requiredErrorMessage),
  //     certificateNumber: Yup.string().typeError(requiredErrorMessage),
  //   }),
  // })
  //   .test('requiredFieldsCheck', requiredErrorMessage, function (value) {
  //     const { fuelName, fuelValue, electricityFromRec } = value || {};
  //     const { emissionValue, providerName, certificateNumber } = electricityFromRec || {};

  //     // Skip validation if all fields are empty and `fuelName` is not marketBasedRECField
  //     if (fuelName !== marketBasedRECField && !fuelValue && !emissionValue && !providerName && !certificateNumber) {
  //       return true;
  //     }

  //     // Array to collect validation errors
  //     const errors: Yup.ValidationError[] = [];

  //     const errorHandler = (path: string, message: string) =>
  //       errors.push(this.createError({
  //         path,
  //         message,
  //       }));


  //     // Validate `fuelValue` if `fuelName` is `marketBasedRECField` and `electricityFromRec` fields are filled
  //     if (fuelName === marketBasedRECField) {
  //       if (!fuelValue && (emissionValue || providerName || certificateNumber)) {
  //         errorHandler(`${this.path}.fuelValue`, requiredErrorMessage);
  //       }

  //       if (fuelValue && !fuelValue.match(MAX_FOUR_DECIMALS_REGEX)) {
  //         errorHandler(`${this.path}.fuelValue`, 'Enter a number with a maximum of 4 decimal places');
  //       }

  //       // Validate `electricityFromRec` fields when `fuelValue` is present or partial `electricityFromRec` fields are filled
  //       [['emissionValue', emissionValue], ['providerName', providerName], ['certificateNumber', certificateNumber]].forEach(([field, fieldValue]) => {
  //         if (fuelValue && !fieldValue) {
  //           errorHandler(`${this.path}.electricityFromRec.${field}`, requiredErrorMessage);
  //         }
  //       });
  //       // Validate `electricityFromRec` fields if any of them is partially filled
  //       const recFields = [
  //         { field: 'emissionValue', value: emissionValue },
  //         { field: 'providerName', value: providerName },
  //         { field: 'certificateNumber', value: certificateNumber }
  //       ];

  //       recFields.forEach(({ field, value }) => {
  //         if (!value && recFields.some(({ value }) => value)) {
  //           errorHandler(`${this.path}.electricityFromRec.${field}`, requiredErrorMessage);
  //         } else if (field === 'emissionValue' && value && !value.match(MAX_FOUR_DECIMALS_REGEX)) {
  //           errorHandler(`${this.path}.electricityFromRec.emissionValue`, 'Enter a number with a maximum of 4 decimal places');
  //         }
  //       });
  //     }

  //     // If any errors were collected, throw them as a single Yup.ValidationError instance with inner errors
  //     if (errors.length > 0) {
  //       const validationError = new Yup.ValidationError('Validation failed', null, this.path);
  //       validationError.inner = errors;  // Set the inner property to the array of errors
  //       throw validationError;
  //     }

  //     return true;
  //   }))
});
